import Navbar from "../common/Navbar"
import HomePage from "../containers/HomePage"
import Pricelistpage from "../containers/Pricelistpage"
import CallButton from "../assets/images/callicon.png"
import { useParams } from "react-router-dom"
const Pricelist = () => {
  let { mobileNum } = useParams()
  const a = mobileNum?.slice(0, 5)
  const b = mobileNum?.slice(7, 12)
  mobileNum = a + b || "+91 95001 39626"
  return (
    <div>
      <Navbar />
      <HomePage />
      <Pricelistpage />
      <a href={`tel:${mobileNum}`}>
        <img src={CallButton} className="dial-contact" />
      </a>
      
    </div>
  )
}
export default Pricelist